<template>
    <div class="relative my-4 mx-2 z-50">
       <button @click="drop_open =! drop_open" class=" relative z-50 block h-8 -w-8 focus:outline-none focus:border-white">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="h-10 w-10 fillcurrent text-gray-600">
                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z" clip-rule="evenodd"/>
            </svg>
       </button>
       <button @click="drop_open=false" tabindex="-1" class="fixed inset-0 h-full w-full bg-gray-800 focus:outline-none opacity-50 cursor-default" v-if="drop_open"></button>
       <div v-if="drop_open" class="absolute right-0 w-48 mt-2 shadow-md bg-gray-500 rounded-lg py-2">
           <Link href="/profile-page"  class="block px-4 py-2 text-white hover:text-black font-bold hover:bg-color-gray-100"> <span  @click="drop_open = false">My profile</span></Link>
           <!-- <router-link to="/update-password"   class="block px-4 py-2 text-white font-bold hover:text-black hover:bg-color-gray-100"><span  @click="drop_open = false"> Change passsword</span></router-link> -->
           <a  href="/logout" class="block px-4 py-2 text-white font-bold hover:text-black hover:bg-color-gray-100 cursor-pointer"> Logout</a>
       </div>
    </div>
</template>
<script>

import { Link } from '@inertiajs/inertia-vue3'
export default {
    data(){
        return{
            drop_open:false,
        }
    },
    components:{
        Link
    },
    created(){
        const handleEscape =(e) =>{
            if(e.key === 'Esc' || e.key === 'Escape'){
                this.drop_open =false;
            }
        }

        document.addEventListener('keydown',handleEscape)

        // this.$once('hook: beforeUnmount',()=>{
        //     document.removeEventListener('keydown',handleEscape)
        // })
    },

}
</script>